import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";

const ServicePage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Services | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Explore Cash Flow Summit 2026 services and resources designed to help business owners improve cash flow, profitability, and financial control."
        />
        <meta
          name="keywords"
          content="Cash Flow Summit services, cash flow strategies, financial control, business profitability"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Service"} pagesub={"Service"} />
      <ServiceSection hclass={"services-section-s3"} />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default ServicePage;
